import { useRouter } from 'next/router';
import React from 'react';

import styles from './LocationLink.module.scss';

interface ILocationLinkProps {
  location: string;
  cities?: string[];
}

const LocationLink = ({ location, cities }: ILocationLinkProps) => {
  const city = getCity(location);
  const inHavenlyCities = cities && isInHavenlyCities(cities, city);

  return (
    <div className={ styles.LocationStyle }>
      <div className={styles.Location}>
        📍&nbsp;
        { inHavenlyCities ? (
          <a className={styles.Location} href={`/interior-designers/${city}`}>
            {location}
          </a>
        ) : (
          <>{ location }</>
        )}
      </div>
    </div>
  );
};

function isInHavenlyCities(cities: string[], city: string) {
  const { query: { slug } } = useRouter();

  return cities?.includes(city) && city !== slug;
}

function getCity(location: string) {
  const city = location.toLowerCase().split(',')[0];

  if (city === 'washington') return 'washington-dc';

  return city;
}

export default LocationLink;
